"use client"

// src/clients/instanceClient.ts
import { createClient } from "@meteor/rpc/client";

// src/clients/config.ts
var import_meta = {};
var _a, _b, _c;
var apiHost = (_c = (_a = window.metorial_config) == null ? void 0 : _a.VITE_API_HOST) != null ? _c : (_b = import_meta == null ? void 0 : import_meta.env) == null ? void 0 : _b.VITE_API_HOST;
var _a2, _b2, _c2;
var authHost = (_c2 = (_a2 = window.metorial_config) == null ? void 0 : _a2.VITE_AUTH_HOST) != null ? _c2 : (_b2 = import_meta == null ? void 0 : import_meta.env) == null ? void 0 : _b2.VITE_AUTH_HOST;
var _a3, _b3, _c3;
var frontendHost = (_c3 = (_a3 = window.metorial_config) == null ? void 0 : _a3.VITE_FRONTEND_HOST) != null ? _c3 : (_b3 = import_meta == null ? void 0 : import_meta.env) == null ? void 0 : _b3.VITE_FRONTEND_HOST;
var _a4, _b4, _c4;
var isProd = (_c4 = (_a4 = window.metorial_config) == null ? void 0 : _a4.PROD) != null ? _c4 : (_b4 = import_meta == null ? void 0 : import_meta.env) == null ? void 0 : _b4.PROD;
var origin = window.location.origin;
if (origin.includes("metorial-staging.click")) {
  apiHost = "dashboard-api.metorial-staging.click";
  authHost = "auth.metorial-staging.click";
  frontendHost = "app.metorial-staging.click";
  isProd = true;
} else if (origin.includes("metorial.com")) {
  apiHost = "dashboard-api.metorial.com";
  authHost = "auth.metorial.com";
  frontendHost = "app.metorial.com";
  isProd = true;
}
var proto = isProd ? "https" : "http";
var getEndpoint = (service) => {
  return `${proto}://${apiHost}/${service}`;
};
var config = {
  dashboardApiUrls: {
    agent: getEndpoint("dashboard"),
    billing: getEndpoint("dashboard"),
    connection: getEndpoint("dashboard"),
    consumer: getEndpoint("dashboard"),
    developer: getEndpoint("dashboard"),
    instance: getEndpoint("dashboard"),
    organization: getEndpoint("dashboard"),
    policy: getEndpoint("dashboard"),
    portal: getEndpoint("dashboard"),
    thread: getEndpoint("dashboard"),
    usage: getEndpoint("dashboard"),
    user: getEndpoint("dashboard")
  },
  authFrontendUrl: `${proto}://${authHost}`,
  dashboardFrontendUrl: `${proto}://${frontendHost}`
};

// src/clients/instanceClient.ts
var instanceClient = createClient({
  endpoint: config.dashboardApiUrls.instance
});
export {
  instanceClient
};
//# sourceMappingURL=instanceClient.mjs.map